import React, { PureComponent } from 'react'
import './style.scss'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Sticky from 'react-stickynode'
import DeleteImagesConfirmationOverlay from '../Layer/DeleteImagesConfirmationOverlay'

class ActionBar extends PureComponent {

  state = {
    loading: false,
    showLayerDeleteSelectedImages: false,
  }

  componentDidMount () {
    document.addEventListener('keydown', this.onKeydown, false)
    /* Dispatch a resize event after render, so actionBar is sticky,
       even if user is already scrolled, otherwise actionbar will only be
       sticky/positioned after user scrolled.
       Issue: https://github.com/yahoo/react-stickynode/issues/61
       Yes 2 dispatches are needed
    */
    const resizeEvent = new Event('resize')
    window.dispatchEvent(resizeEvent)
    window.dispatchEvent(resizeEvent)
  }

  componentWillUnmount () {
    document.removeEventListener('keydown', this.onKeydown, false)
  }

  showLayerDeleteSelectedImages = () => {
    this.setState({ showLayerDeleteSelectedImages: true })
  }

  hideLayerDeleteSelectedImages = () => {
    this.setState({ showLayerDeleteSelectedImages: false })
  }

  onKeydown = (e) => {
    if (e.keyCode === 27) {
      this.isCancelAllowed() && this.props.onCancelClick()
    }
  }

  isCancelAllowed () {
    return this.state.showLayerDeleteSelectedImages === false
      && this.state.showLayerDeleteSelectedImages === false
  }

  render () {
    const { t } = this.props
    const selectedImagesCount = this.props.selectedImages.length
    return (
      <Sticky enabled={true} top={0} innerZ={1800} enableTransforms={false}>
        <div className={'image-browser-action-bar'}>
          <div className={'action-bar-info'}>
          <span className={'icon-wrapper'} onClick={this.props.onCancelClick}>
            <i className="icon-close" title={t('CANCEL')}/>
          </span>
            <span>{t('N_SELECTED', { count: selectedImagesCount })}</span>
          </div>
          <div className={'action-bar-actions'}>
          <span className={'icon-wrapper'} onClick={this.showLayerDeleteSelectedImages}>
            <i className="giata-icon-trash" title={t('BUTTON_DELETE')}/>
          </span>
          </div>
          {
            this.state.showLayerDeleteSelectedImages && <DeleteImagesConfirmationOverlay
              giataId={this.props.giataId}
              images={this.props.selectedImages}
              onCancel={this.hideLayerDeleteSelectedImages}
              onDeleted={this.props.onImagesDeleted}
            />
          }
        </div>
      </Sticky>
    )
  }
}

ActionBar.propTypes = {
  giataId: PropTypes.number.isRequired,
  selectedImages: PropTypes.array.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  onImagesDeleted: PropTypes.func.isRequired
}
export default withTranslation()(ActionBar)
